import {FeatureEntry, FeaturesMenu, MenuNodeType} from '../../api/types/featuresMenu'

export const getHomeFeature = (featuresMenu: FeaturesMenu): FeatureEntry | undefined => {
  for (const entry of featuresMenu) {
    if (entry.type === MenuNodeType.Feature && entry.isHomePage) {
      return entry
    }

    if (entry.type === MenuNodeType.Folder) {
      const found = getHomeFeature(entry.children)

      if (found) return found
    }
  }

  return undefined
}
